import {MechanicEventDiceState} from '@colonist/game-states'
import {UIGameDiceController} from '../../ui_game_dice/UIGameDiceController'
import {UIGameManager} from '../../UIGameManager'

export abstract class UIGameEventDiceController extends UIGameDiceController {
    protected readonly eventDiceState: MechanicEventDiceState

    constructor(uiGameManager: UIGameManager, eventDiceState: MechanicEventDiceState) {
        super(uiGameManager)
        this.eventDiceState = eventDiceState
        this.initializeOpponentDiceViews()
        this.initializeCurrentTurnPlayer()
        this.updateDiceImage()
        this.updateDiceView()
    }
}
